import { Button, Flex, Grid, Paper, Text, Title } from '@mantine/core';
import { DangerouslySetInnerHTML } from '@shared/ui';
import { IconPencil } from '@tabler/icons-react';
import type { CandidateResumeDisplayValues } from '../types';

type CandidateResumeCardProps = CandidateResumeDisplayValues & {
  onEdit: () => void;
};

export const CandidateResumeCard = ({
  profession,
  desiredJob,
  skills,
  experience,
  salary,
  scheduleWorks,
  employmentTypes,
  onEdit,
}: CandidateResumeCardProps) => (
  <Paper p={24} radius={16} bg='primary.0' w='100%' maw={1070}>
    <Flex gap={24} direction='column'>
      <Flex justify='space-between' align='center' gap={16} wrap='wrap'>
        <Title order={4}>Условия работы</Title>
        <Button
          variant='subtle'
          size='md'
          leftSection={<IconPencil size={20} />}
          onClick={onEdit}
        >
          Редактировать
        </Button>
      </Flex>

      <Grid gutter={{ base: 24, sm: 32 }}>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <Flex direction='column' gap={24}>
            <DataField label='Профессия' value={profession} />
            <DataField label='Желаемая должность' value={desiredJob} />
            <DataField label='Ключевые навыки' value={skills} />
            <DataField
              label='Опыт работы'
              value={<DangerouslySetInnerHTML __html={experience} />}
            />
          </Flex>
        </Grid.Col>

        <Grid.Col span={{ base: 12, sm: 6 }}>
          <Flex direction='column' gap={24}>
            <DataField label='Уровень дохода от' value={salary} />
            <DataField label='График работы' value={scheduleWorks} />
            <DataField label='Тип занятости' value={employmentTypes} />
          </Flex>
        </Grid.Col>
      </Grid>
    </Flex>
  </Paper>
);

type DataFieldProps = {
  label: string;
  value: React.ReactNode;
};

const DataField = ({ label, value }: DataFieldProps) => (
  <Flex direction='column' gap={8} style={{ minWidth: 0 }}>
    <Text c='tertiary.7' size='sm'>
      {label}
    </Text>
    <Text
      component='div'
      c='primary.7'
      style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}
    >
      {value}
    </Text>
  </Flex>
);
